module.exports = __webpack_public_path__ + "static/media/404.6d991742.png";